import lodash from 'lodash'
import i18n from '@/i18n'

const EMPTY_FILTER_KEY = 'INDEX.label_empty_value'
export const EMPTY_FILTER_VALUE = '(空)'

function getEmptyFilterValue() {
  const value = i18n._t(EMPTY_FILTER_KEY, i18n.locale, i18n._getMessages())
  return value === EMPTY_FILTER_KEY ? EMPTY_FILTER_VALUE : value
}

function isBlankValue(value) {
  if (lodash.isNil(value)) return true
  if (lodash.isString(value)) return lodash.isEmpty(lodash.trim(value))
  return false
}

export function createEmptyFilters(fields = []) {
  return lodash.fromPairs(fields.map((field) => [field, []]))
}

export function resetTableFilters(filters = {}) {
  return lodash.mapValues(filters, () => [])
}

export function buildFilterOptions(
  rows = [],
  fields = [],
  emptyValue = getEmptyFilterValue()
) {
  return lodash.fromPairs(
    fields.map((field) => {
      const values = lodash.uniq(
        rows.map((row) => row[field]).filter((value) => !isBlankValue(value))
      )

      if (rows.some((row) => isBlankValue(row[field]))) {
        values.push(emptyValue)
      }
      return [field, values]
    })
  )
}

export function applyTableFilters(
  rows = [],
  filters = {},
  options = {},
  emptyValue = getEmptyFilterValue()
) {
  return lodash.reduce(
    filters,
    (result, selected, field) => {
      const optionValues = options[field] || []
      if (!selected.length || selected.length === optionValues.length) {
        return result
      }

      return result.filter(
        (row) =>
          selected.includes(row[field]) ||
          (selected.includes(emptyValue) && isBlankValue(row[field]))
      )
    },
    rows
  )
}

export function normalizeFilterValues(
  filters = {},
  options = {},
  emptyValue = getEmptyFilterValue()
) {
  return lodash.mapValues(filters, (selected = [], field) => {
    const optionValues = options[field] || []

    return selected.filter(
      (value) => value === emptyValue || optionValues.includes(value)
    )
  })
}
